module.exports = __webpack_public_path__ + "media/images/area-badges/sustainable-cities-communities-e41782e695b5d643a0ffaf94751e808a.svg";